const ONE_UP = 'ONE.UP';
const ONE_DOWN = 'ONE.DOWN';

export { ONE_UP, ONE_DOWN };
